import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/slices/header-slice.js';
import SubLinks from '../../components/header/SubLinks.jsx';
import { adminLinks } from '../../config/standard-links.js';
import AoarForm from '../../components/admin-automations/AoarForm.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';

/**
 * Component for rendering the AOAR automation page.
 * @returns {JSX.Element} AOAR automation page component.
 */
const AoarPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setActiveTab('Admin'));

        return () => {
            dispatch(setActiveTab(null));
        };
    });

    return (
        <div>
            <SubLinks links={adminLinks} />
            <div className="newsc-container">
                <br />
                <br />
                <br />
                <div className="create-office-heading">
                    <BackArrow navigateTo={-1} />
                    <h2>AOAR Automation</h2>
                </div>
                <br />
                <AoarForm />
            </div>
        </div>
    );
};

export default AoarPage;
